
export default function Approach() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#f8f9f8] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#444c42] mb-4">
            Your Comfort is Our Priority
          </h2>
          <p className="text-lg text-[#7A8178] max-w-3xl mx-auto leading-relaxed">
            At Beaulieu Dental, we understand that visiting the dentist can be stressful. That's why we've created a patient-centred approach designed to put you at ease from the moment you walk through our doors.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h3 className="text-3xl font-bold text-[#444c42] mb-6">
              Our Anxiety-Friendly Philosophy
            </h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#d0a24f] to-[#dcb964] flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-pulse-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-[#444c42] mb-2">Listen First, Treat Second</h4>
                  <p className="text-[#7A8178] leading-relaxed">
                    We take time to understand your concerns, fears, and dental history before any treatment begins.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#d0a24f] to-[#dcb964] flex items-center justify-center flex-shrink-0">
                  <i className="ri-hand-heart-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-[#444c42] mb-2">You're Always in Control</h4>
                  <p className="text-[#7A8178] leading-relaxed">
                    Use our agreed-upon signal anytime you need a break. We'll stop immediately—no questions asked.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#d0a24f] to-[#dcb964] flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-[#444c42] mb-2">Gentle, Modern Techniques</h4>
                  <p className="text-[#7A8178] leading-relaxed">
                    We use the latest pain-free technology and sedation options to ensure maximum comfort.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#d0a24f] to-[#dcb964] flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-[#444c42] mb-2">No Rush, No Pressure</h4>
                  <p className="text-[#7A8178] leading-relaxed">
                    We schedule longer appointments for anxious patients so you never feel rushed or pressured.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#d0a24f]/20 to-[#dcb964]/20 rounded-3xl transform -rotate-3"></div>
            <img
              src="https://static.readdy.ai/image/0a3008c36638439fa5d134c9c6a19be7/63fed2ef7caf43df5cb11eba1ef234db.jpeg"
              alt="Compassionate dentist providing gentle care to relaxed patient at Beaulieu Dental"
              title="Patient-centred anxiety-friendly dental care in Chelmsford"
              className="relative rounded-3xl shadow-2xl w-full h-[500px] object-cover object-top"
            />
          </div>
        </div>

        {/* CTA Section with Green Background */}
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#444c42] via-[#7A8178] to-[#444c42] p-12 text-center">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-64 h-64 bg-[#d0a24f] rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#dcb964] rounded-full blur-3xl"></div>
          </div>
          
          <div className="relative z-10">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to Take the First Step Towards Stress-Free Dentistry?
            </h3>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Book your free consultation today and discover how comfortable dental care can be.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="https://beaulieudental.co.uk/book-free-consultation/"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2 bg-gradient-to-r from-[#d0a24f] to-[#dcb964] text-white px-8 py-4 rounded-full font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-check-line text-xl"></i>
                Book Your Free Consultation
                <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
              </a>
              
              <a
                href="tel:01245465586"
                className="group inline-flex items-center gap-2 bg-white text-[#444c42] px-8 py-4 rounded-full font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Call Us: 01245 465586
                <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}